// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__azqA5","title":"ClientCherryInfo_title__1ta9Q","itemText":"ClientCherryInfo_itemText__3V4SA"};